import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/utils/services/app.service';
import { ApiService } from 'src/app/utils/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  public registerForm: FormGroup;
  admin_id: string;
  public isAuthLoading = false;
  public isAuthDisabled = false;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.renderer.addClass(document.querySelector('app-root'), 'register-page');

    this.registerForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/)
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/)
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
      mobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]),
      password: new FormControl('', [
        Validators.required,Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/)
      ]),
      retypePassword: new FormControl('', [
        Validators.required,Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/)
      ]),
    });

    this.admin_id = this.route.snapshot.paramMap.get('admin_id');
    if (this.admin_id) {
      this.editAdmin(this.admin_id);
    }
  }

  async register() {
    const password = this.registerForm.get('password')?.value;
    const retypePassword = this.registerForm.get('retypePassword')?.value;
  
    if (password !== retypePassword) {
      this.toastr.error('Passwords do not match');
      return;
    }
    if (this.registerForm.invalid) {
      this.toastr.error('Please fill all the fields correctly');
      return;
    }

    if (this.admin_id) {
      this.updateAdmin(this.admin_id);
      return;
    }

    this.isAuthLoading = true;
    this.isAuthDisabled = true;

    let loginData = {
      firstname: this.registerForm.value.firstName,
      lastname: this.registerForm.value.lastName,
      email: this.registerForm.value.email,
      mobile: this.registerForm.value.mobile,
      password: this.registerForm.value.password,
      confirm_password: this.registerForm.value.retypePassword,
      role: '1'
    };

    await this.apiService.onRegister(JSON.stringify(loginData)).subscribe((result: any) => {
      this.isAuthLoading = false;
      this.isAuthDisabled = false;

      if (result.success) {
        this.toastr.success(result.message);
        this.router.navigate(['/admin-list']);
      } else {
        this.toastr.error(result.message);
      }
    });
  }

  editAdmin(id: string) {
    this.registerForm.get('email')?.disable();

    let dataForForm = { id };

    this.apiService.getAdmin(JSON.stringify(dataForForm)).subscribe((result: any) => {
      if (result.success) {
        let adminData = result.getData;
        this.registerForm.patchValue({
          firstName: adminData.firstname,
          lastName: adminData.lastname,
          email: adminData.email,
          mobile: adminData.mobile,
          password: adminData.password,
          retypePassword: adminData.password
        });
      } else {
        this.toastr.error(result.message);
      }
    });
  }

  async updateAdmin(id: string) {
    this.isAuthLoading = true;
    this.isAuthDisabled = true;

    let editData = {
      firstname: this.registerForm.value.firstName,
      lastname: this.registerForm.value.lastName,
      mobile: this.registerForm.value.mobile
    };

    await this.apiService.updateAdminById(id, JSON.stringify(editData)).subscribe((result: any) => {
      this.isAuthLoading = false;
      this.isAuthDisabled = false;

      if (result.success) {
        this.toastr.success(result.message);
        this.router.navigate(['/admin-list']);
      } else {
        this.toastr.error(result.message);
      }
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.querySelector('app-root'), 'register-page');
  }


  onlyAlphabetKey(event: KeyboardEvent) {
    const regex = /^[A-Za-z]+$/;
    if (!regex.test(event.key) && event.key !== 'Backspace' && event.key !== ' ') {
      event.preventDefault();
    }
  }

  // Allows only numbers for mobile input
  onlyNumberKey(event: KeyboardEvent) {
    const regex = /^[0-9]$/;
    if (!regex.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
}
